import { ArrowDropDown, Info as Info$1 } from "@mui/icons-material";
import { Button, MenuItem, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SliderFilter } from "../../assets/icons/SliderFilter.js";
import { Status } from "../../todo-list.types.js";
import "react/jsx-runtime";
const StatusBox = styled("div", {
  shouldForwardProp: (props) => props !== "margin" && props !== "readonly"
})(({ theme, state, readonly }) => ({
  display: "flex",
  padding: "4px 4px 4px 8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "4px",
  borderRadius: "4px",
  backgroundColor: theme.palette.warning[100],
  cursor: "pointer",
  ...state === Status.DONE && {
    backgroundColor: theme.palette.success[100]
  },
  ...state === Status.IGNORED && {
    backgroundColor: theme.palette.grey[200]
  },
  ...readonly && {
    cursor: "default",
    padding: "4px 8px"
  }
}));
const SortButton = styled(Button)(({ theme, filters }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: theme.spacing(0.5),
  backgroundColor: "#ffffff",
  color: theme.palette.grey[800],
  height: theme.spacing(4),
  borderRadius: theme.spacing(1),
  boxShadow: "0px 0.5px 1.5px 0px #0000001a",
  paddingLeft: "16px",
  paddingRight: "8px",
  boxSizing: "border-box",
  flexShrink: filters ? 0 : 1
}));
const SortMenuItem = styled(MenuItem)(({ theme, selected }) => ({
  backgroundColor: selected ? theme.palette.primary[75] : "transparent",
  "&:hover": {
    backgroundColor: selected ? theme.palette.primary[75] : theme.palette.primary[50]
  }
}));
const SliderFilterIcon = styled(SliderFilter)({
  width: "16px",
  height: "16px"
});
const Counter = styled("div")(({ theme }) => ({
  minWidth: "18px",
  borderRadius: "50%",
  fontSize: "12px",
  padding: "0 3px",
  boxSizing: "border-box",
  backgroundColor: theme.palette.primary[75]
}));
const Container = styled("div")({
  display: "flex",
  gap: "4px",
  alignItems: "center"
});
const ArrowDownIcon = styled(ArrowDropDown)({
  width: "16px",
  height: "16px"
});
const Switch = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "10px"
});
const Text = styled(Typography, {
  shouldForwardProp: (props) => props !== "margin"
})(({ theme, state }) => ({
  color: theme.palette.grey[900],
  textAlign: "center",
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
  ...state === Status.TO_DO && {
    color: theme.palette.grey[900]
  },
  ...state === Status.DONE && {
    color: theme.palette.success[900]
  },
  ...state !== Status.IGNORED && {
    color: theme.palette.grey[800]
  }
}));
const Info = styled(Info$1)(({ theme }) => ({
  color: theme.palette.grey[500],
  width: "20px",
  height: "20px"
}));
export {
  ArrowDownIcon,
  Container,
  Counter,
  Info,
  SliderFilterIcon,
  SortButton,
  SortMenuItem,
  StatusBox,
  Switch,
  Text
};
